/**
 * For each piece of site functionality that requires javascript, create a module file for import.
 *
 * Each module should export an object that has an init() method on it. This method gets called when the document has loaded.
 *
 * This method prevents long files from being used, allows for better organization, and prevents separate files from calling the onload method multiple times.
 *
 * If you need to add js files that don't need to be loaded on every page, make a separate js file and add a compile function for it in the webpack.mix.js file, then enqueue it conditionally as needed.
 */
import ModuleLoader from './loader/ModuleLoader';

// Custom modules
import menu from './modules/menu';
import accordions from "./modules/accordions";
import accordionMenu from "./modules/accordionMenu";
import dropdownMenu from "./modules/dropdownMenu";
import scrollTop from "./modules/scrollTop";
import donationAjax from "./modules/donationAjax";
import modal from "./modules/modal";
import ecard from "./modules/ecard";

const modules = new ModuleLoader({
	menu, accordions, accordionMenu, dropdownMenu, scrollTop, donationAjax, modal, ecard
});

window.onload = (event) => {
	modules.init();
};
